(function () {
	"use strict";
    
	var app = angular.module('cccu.universitySurveys.surveys', ['ui.router']);
	
	app.config(function ($stateProvider) {
		$stateProvider.state('surveys', {
            url: '/surveys',
            views: {
                "main": {
                    controller: 'SurveysCtrl',
                    templateUrl: 'surveys/surveys.html'
                }
            },
            data: { pageTitle: 'University Surveys' }
        });
	});
	
	app.controller('SurveysCtrl', ['$scope', 'UniversitySurveyService', function ($scope, surveyService) {
		$scope.loadingScreen = true;
		surveyService.getSurveys().then(function (data) {
			$scope.loadingScreen = false;
			scope.surveyDetails = routerUrl;
		}, function (error) {
			$scope.loadingScreen = false;
		});
	}]);
}());